// ---------------------------------------------------------------------------
// Geolocation (§7.5, §1). Attempt navigator.geolocation only when the user asks
// (never auto-requested on page load — §1.3); if granted we pass
// latitude/longitude so the API returns `distance` and nearest-first ordering.
// If denied/unavailable, resolve to null and the flow proceeds without it.
// ---------------------------------------------------------------------------

export interface Coords {
  latitude: number
  longitude: number
}

/**
 * Request the current position. `fresh` forces a brand-new fix (maximumAge 0) so
 * pressing "locate" always re-queries the device rather than returning a cached
 * position — the fix for §1.5 (locate did nothing after a prior selection).
 */
export function requestGeolocation(timeoutMs = 8000, fresh = false): Promise<Coords | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) return resolve(null)
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: fresh ? 0 : 5 * 60 * 1000 }
    )
  })
}
